// Generated by scripts/build-ui-icons.mjs.
export { Crosshair as default } from "../ui/glyphs-3";
